import { CALYPSO, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SupportCluster = ({
  iconName,
  title,
  description,
  className
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: `flex-row ${className}`,
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIIconCircle, {
        name: iconName,
        backgroundColor: CALYPSO_LIGHT,
        color: CALYPSO,
        borderWidth: 0,
        size: 36,
        className: "m-right-6",
        style: {
          minWidth: '70px',
          minHeight: '70px',
          padding: '16px'
        }
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        "aria-level": 3,
        marginBlockEnd: "100",
        children: title
      }), /*#__PURE__*/_jsx("p", {
        className: "m-all-0",
        children: description
      })]
    })]
  });
};
export const ProPlusSupportContent = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center justify-between m-y-15",
    children: [/*#__PURE__*/_jsx(H2, {
      "aria-level": 2,
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgradePages.trialUpgradePage.proPlusSupport.header"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      align: "center",
      children: [/*#__PURE__*/_jsx(SupportCluster, {
        iconName: "audioInputOutput",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.liveSupport.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.liveSupport.body"
        }),
        className: "m-right-6"
      }), /*#__PURE__*/_jsx(SupportCluster, {
        iconName: "cap",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.assistedOnboarding.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.assistedOnboarding.body"
        }),
        className: "m-left-6"
      })]
    })]
  });
};